// extracted by mini-css-extract-plugin
module.exports = {"Menu":"Menu_Menu__3JZpz","Container":"Menu_Container__aCubx","Close":"Menu_Close__332s3"};